module.exports = __webpack_public_path__ + "img/labz-dash-fork.0cb70dc4.png";